import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute("/_authenticated/collections")({
  component: CollectionsLayout,
});

/** Registros de colecciones propias: techo del módulo collection_records. */
function CollectionsLayout() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "collection_records", actions: ["read"] }]}
    >
      <Outlet />
    </RouteGuardPermissions>
  );
}
